function empreendimentoJsonModel() {
	return {
		cod_empreendimento: null,
		unidades: null,
	};
}

export default empreendimentoJsonModel;
